/**
 * Estado sintético — **não é um valor que a API devolve.**
 *
 * Enquanto a coleta tem contestação ativa, o estado dela na coluna "Status coleta" é
 * "Contestada": a mesma palavra que a medição usa para `release_status = CONTESTED` (ver
 * `measurementStatus.ts`), para o gerador ler o mesmo rótulo nos dois níveis do extrato.
 *
 * Antes a célula mostrava o estado da **contestação** ("Aberta", "Em análise"…), que responde
 * outra pergunta: aquela é a vida do pedido, esta é a situação da coleta. O ciclo de vida da
 * contestação continua visível onde ele é o assunto — o Histórico de contestações.
 */
export const COLLECT_STATUS_CONTESTED = 'contested';

/** Estado da coleta faturada, no vocabulário do gerador (`engine_collect_vw.status`). */
export const COLLECT_STATUS_CONFIG: Record<
  string,
  { label: string; variant: 'info' | 'warning' | 'success' | 'destructive' | 'secondary' }
> = {
  collected: { label: 'Coletado',   variant: 'success' },
  fault:     { label: 'Impedido',   variant: 'warning' },
  planned:   { label: 'Planejada',  variant: 'info' },
  expired:   { label: 'Expirada',   variant: 'secondary' },
  [COLLECT_STATUS_CONTESTED]: { label: 'Contestada', variant: 'destructive' },
};

export function collectStatusLabel(status: string | null | undefined): string | null {
  if (!status) return null;
  return COLLECT_STATUS_CONFIG[status]?.label ?? status;
}
